export enum CardSize {
    LARGE = 'large',
    MEDIUM = 'medium',
}
